import { PanelEditorScope } from "../panels/panel-editor-scope";
import { LouvreCutoutsEditorDockingPanelContent } from "./content/louvre-cutouts/louvreCutoutsEditorDockingPanelContent";
import { DockingPanel } from "./dockingPanel";

export class LouvreCutoutsEditorDockingPanel {
    private readonly panel: DockingPanel;
    private visible: boolean;

    constructor(container: HTMLElement, panelEditorScope: PanelEditorScope) {
        this.visible = false;

        const component = <LouvreCutoutsEditorDockingPanelContent panelEditorScope={panelEditorScope} />;

        this.panel = new DockingPanel(
            container,
            "dextall-studio-louvre-cutouts-editor",
            "Louvre cutouts editor",
            component,
            {
                style: {
                    resize: "both",
                },
                dimensionsControl: {
                    preventOverlapsWithViewerToolbar: true,
                    widthDimensionControl: { value: 500, minValue: 500 },
                    heightDimensionControl: { value: 500, minValue: 500 },
                    topOffset: 250,
                    leftOffset: 540,
                },
                carefullBringToFront: true,
            },
        );

        this.onViewerPanelVisibilityChanged = this.onViewerPanelVisibilityChanged.bind(this);
        this.panel.addVisibilityListener(this.onViewerPanelVisibilityChanged);
    }

    onVisibilityChanged?: (visibility: boolean) => void;

    setVisible(visibility: boolean) {
        if (this.visible === visibility) {
            return;
        }
        this.visible = visibility;
        this.panel.setVisible(visibility);
    }

    shutdown() {
        this.panel.shutdown();
        this.onVisibilityChanged = undefined;
    }

    private onViewerPanelVisibilityChanged(visibility: boolean) {
        this.visible = visibility;
        this.onVisibilityChanged?.(visibility);
    }
}
